export const PUBLISHER_LIST = {
  TITLE: 'Review and Save Custom List',
  DESCRIPTION: 'Fintel Check will be performed on the following publishers:',
  BACK: 'Back',
  SAVE: 'Save Custom List',
};
